import * as taskTypesService from '../../../../../../services/api/task-types-api';

export async function fetchTaskTypes() {
    // TAD-5783 -- Multi-admin Task Type Access: the admin table reads from the
    // dedicated /api/task-types/admin endpoint so each row carries the server-
    // computed IsEditable flag and the creator's SubDepartments (AC#2, AC#3, AC#4).
    return taskTypesService.getAdminTaskTypes();
}

// taskTypeIds: int[]
export async function deleteTaskTypes(taskTypeIds) {
    const promises = [];

    for (const id of taskTypeIds) {
        promises.push(taskTypesService.deleteTaskType(id));
    }

    return Promise.all(promises);
}

// taskTypes: TaskTypeDto[] (to sort)
// sortBy: property to compare
// isSortDescending: bool
// pageNumber: int
// pageSize: int
export function sortTasks({ taskTypes, sortBy, isSortDescending, pageNumber, pageSize }) {
    const taskTypesCopy = [...taskTypes];

    if (sortBy) {
        taskTypesCopy.sort((a, b) => {
            let comparison = 0;
            if (a[sortBy] > b[sortBy]) {
                comparison = 1;
            } else if (a[sortBy] < b[sortBy]) {
                comparison = -1;
            } else {
                comparison = 0;
            }
            if (!isSortDescending) return -comparison;
            return comparison;
        });
    }

    const startIndex = pageSize * (pageNumber - 1);
    return taskTypesCopy.slice(startIndex, startIndex + pageSize);
}
